<!--
 * @Description: 子框架布局
 * @Author: PF
 * @Date: 2026-08-25 15:15:11
 * @LastEditors: PF
 * @LastEditTime: 2026-08-26 10:24:24
-->
<template>
  <div class="zi-kuang-jia" @click="hidePanel">
    <!-- 左侧菜单 -->
    <div class="menu" v-show="kaiGuan">
      <el-menu unique-opened :default-active="currentMenuUrl" class="el-menu-vertical-demo" style="height: calc(100% - 50px);overflow: auto;" @select="menuSelect">
        <div v-for="(item, index) in menuList" :key="index">
          <el-sub-menu v-if="item.children && item.children.length" :index="item.cdlj">
            <template #title>
              <div class="default_main_tone"><span>{{item.cdmc}}</span></div>
            </template>
            <el-menu-item v-for="(ite, ind) in item.children" :key="ind" :index="ite.cdlj">{{ite.cdmc}}</el-menu-item>
          </el-sub-menu>
          <el-menu-item v-else :index="item.cdlj">{{item.cdmc}}</el-menu-item>
        </div>
      </el-menu>
      <el-button v-if="xtszData.xtjs && xtszData.xtjs.sfxs" type="info" style="width: 200px;position: absolute;bottom: 10px;left: 10px;right: 10px;" @click="openDetail=true">系统介绍</el-button>
    </div>
    <!-- 开关 -->
    <div class="kaiGuan" :style="kaiGuan ? 'left: 220px;' : 'left: 0;'">
      <el-icon class="kaiGuanBut pointer" v-if="kaiGuan" @click="kaiGuanClick(false)"><ArrowLeft /></el-icon>
      <el-icon class="kaiGuanBut pointer" v-else @click="kaiGuanClick(true)"><ArrowRight /></el-icon>
    </div>
    <!-- 内容区域 -->
    <div class="content" :style="kaiGuan ? 'width: calc(100% - 220px);margin-left: 220px;' : 'width: 100%; margin-left: 0;'">
      <el-tabs type="border-card" v-model="currentMenuUrl" closable @tab-remove="handleTabRemove" @tab-change="handleTabChange">
        <el-tab-pane :name="homeInfo.cdlj" :closable="false" label="首页"></el-tab-pane>
        <el-tab-pane v-for="(item, index) in menu" :key="index" :name="item.cdlj">
          <template #label>
            <div @contextmenu.prevent="openMenu($event, item, index)">{{ item.cdmc }}</div>
          </template>
        </el-tab-pane>
      </el-tabs>
      <ul id="myPanel" v-if="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
        <li><el-button link @click="handleTabRemove(dqcd.cdlj)">关闭</el-button></li>
        <li><el-button link @click="removeTab(dqcd.id, '左侧')" :disabled="dqcdind === 0">关闭左侧</el-button></li>
        <li><el-button link @click="removeTab(dqcd.id, '右侧')" :disabled="menu.length === dqcdind + 1">关闭右侧</el-button></li>
        <li><el-button link @click="removeTab(dqcd.id, '其他')" :disabled="menu.length === 1">关闭其他</el-button></li>
        <li><el-button link @click="removeTab(dqcd.id, '全部')" :disabled="menu.length === 1">关闭全部</el-button></li>
      </ul>
      <div class="tab_nei_rong">
        <router-view v-slot="{ Component }" :key="$route.query.t">
          <keep-alive v-if="$route.meta.keepAlive"><component :is="Component" /></keep-alive>
          <component v-if="!$route.meta.keepAlive" :is="Component" />
        </router-view>
      </div>
    </div>
  </div>
  <xitongjieshao v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, watch, onMounted, onActivated } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { actionPost } from '@/api/common'
import xitongjieshao from '@/components/bangzhu/xitongjieshao.vue'

const router = useRouter()
const route = useRoute()

const row = ref({ xtid: sessionStorage.getItem('CURRENT_SYSTEM_ID') })
const openDetail = ref(false)
const xtszData = ref({ xtjs: {} })
const kaiGuan = ref(true)
const currentMenuUrl = ref(route.path)
const menu = ref([]) // 子标签列表
const menuList = ref([]) // 左侧菜单树
const systemMenu = ref([]) // 系统标签缓存（含每个系统的children）
const homeInfo = ref({}) // 当前系统首页信息

// ===== 核心：切换系统时同步恢复菜单 + 子标签 =====
const resetSystem = () => {
  const sysId = sessionStorage.getItem('CURRENT_SYSTEM_ID')
  row.value.xtid = sysId

  // 1. 从 sessionStorage 读取该系统信息（含 children 子标签历史）
  systemMenu.value = JSON.parse(sessionStorage.getItem('SET_SYSTEM_LIST')) || []
  homeInfo.value = systemMenu.value.find(item => item.id === sysId) || {}

  // 2. 同步切换子标签：恢复该系统的历史子标签，不清空！
  menu.value = homeInfo.value?.children || []

  // 3. 高亮首页
  const homePath = homeInfo.value.cdlj || '/' + (route.path.split('/')[1] || '') + '/home'
  currentMenuUrl.value = homePath

  // 4. 重新加载左侧菜单树
  initMenuList(sysId)
}

// ===== 加载左侧菜单 =====
const initMenuList = (sysId = sessionStorage.getItem('CURRENT_SYSTEM_ID')) => {
  actionPost({
    url: '/api/v2/sys/menu/currentusermenuquanxian',
    data: { parentID: sysId }
  }).then((res) => {
    menuList.value = res.data
    // 菜单加载完后，如果当前不是 home，尝试补标签
    if (!route.path.endsWith('/home')) {
      addTagByRoute(route)
    }
  })
}

// 初始化
onMounted(() => {
  const data = sessionStorage.getItem('XITONGSHEZHI')
  if (data) xtszData.value = JSON.parse(data)
  resetSystem() // ✅ 统一入口，首次加载也走这里
})

// ===== 监听路由：检测系统切换 or 页面跳转 =====
let prevSys = route.path.split('/')[1] || ''

watch(() => route.path, (newPath) => {
  const newSys = newPath.split('/')[1] || ''

  if (newSys && newSys !== prevSys) {
    // ✅ 切换了系统（父框架标签切换）
    prevSys = newSys
    resetSystem()
  } else if (newPath.endsWith('/home') || newPath.split('?')[0].endsWith('/home')) {
    // ✅ 同一系统内跳到首页：只高亮，不清空子标签
    currentMenuUrl.value = newPath
    sessionStorage.setItem('menuId', homeInfo.value.id || '')
    sessionStorage.setItem('menuName', '首页')
  } else {
    // ✅ 同一系统内打开新页面：自动添加子标签
    addTagByRoute(route)
  }
})

// 兼容 KeepAlive
onActivated(() => {
  const newSys = route.path.split('/')[1] || ''
  if (newSys !== prevSys) {
    prevSys = newSys
    resetSystem()
  }
})

// ===== 根据路由自动生成标签（home 不生成子标签）=====
const addTagByRoute = (to) => {
  const path = to.path
  if (path.endsWith('/home') || path.split('?')[0].endsWith('/home')) {
    currentMenuUrl.value = path
    return
  }
  const findMenu = (list) => {
    for (const item of list) {
      if (item.cdlj === path) return item
      if (item.children?.length) { const f = findMenu(item.children); if (f) return f }
    }
    return null
  }
  if (!menuList.value.length) return
  const menuItem = findMenu(menuList.value)
  if (menuItem) {
    const exists = menu.value.some(item => item.cdlj === menuItem.cdlj)
    if (!exists) {
      menu.value.push(menuItem)
      // 同步到 sessionStorage（持久化该系统的子标签）
      const sysMenu = JSON.parse(sessionStorage.getItem('SET_SYSTEM_LIST')) || []
      sysMenu.forEach((item) => {
        if (item.id === sessionStorage.getItem('CURRENT_SYSTEM_ID')) {
          if (!item.children) item.children = []
          if (!item.children.some(c => c.cdlj === menuItem.cdlj)) {
            item.children.push(menuItem)
          }
        }
      })
      sessionStorage.setItem('SET_SYSTEM_LIST', JSON.stringify(sysMenu))
    }
    sessionStorage.setItem('menuId', menuItem.id)
    sessionStorage.setItem('menuName', menuItem.cdmc)
  }
  currentMenuUrl.value = path
}

// 菜单点击：只负责跳转
const menuSelect = (index) => {
  router.push({ path: index, query: { t: Date.now() } })
}
// 标签切换
const handleTabChange = (name) => {
  if (name && name !== route.path) router.push({ path: name })
}
// 删除子标签
const handleTabRemove = (val) => {
  visible.value = false
  menu.value = menu.value.filter(item => item.cdlj !== val)
  updateSessionMenu()
  if (val === route.path) {
    // 关掉当前页 → 跳回首页
    router.push({ path: homeInfo.value.cdlj || '/' + prevSys + '/home' })
  }
}
const updateSessionMenu = () => {
  const sysMenu = JSON.parse(sessionStorage.getItem('SET_SYSTEM_LIST')) || []
  sysMenu.forEach((item) => {
    if (item.id === sessionStorage.getItem('CURRENT_SYSTEM_ID')) {
      item.children = menu.value
    }
  })
  sessionStorage.setItem('SET_SYSTEM_LIST', JSON.stringify(sysMenu))
}
// 右键菜单
const visible = ref(false)
const dqcd = ref({})
const dqcdind = ref()
const top = ref(0)
const left = ref(0)
const openMenu = (e, item, index) => {
  dqcd.value = item; dqcdind.value = index
  top.value = e.pageY; left.value = e.pageX; visible.value = true
}
const removeTab = (id, type) => {
  visible.value = false
  const sysList = JSON.parse(sessionStorage.getItem('SET_SYSTEM_LIST'))
  const sysInd = sysList.findIndex(i => i.id === sessionStorage.getItem('CURRENT_SYSTEM_ID'))
  const cdInd = sysList[sysInd].children.findIndex(i => i.id === id)
  const cdInfo = sysList[sysInd].children[cdInd]
  if (type === '左侧') sysList[sysInd].children.splice(0, cdInd)
  if (type === '右侧') sysList[sysInd].children.splice(cdInd + 1)
  if (type === '其他') sysList[sysInd].children = [cdInfo]
  if (type === '全部') {
    sysList[sysInd].children = []
    router.push({ path: homeInfo.value.cdlj || '/' + prevSys + '/home' })
  }
  sessionStorage.setItem('SET_SYSTEM_LIST', JSON.stringify(sysList))
  menu.value = sysList[sysInd].children
  if (type !== '全部') router.push({ path: cdInfo.cdlj, query: { t: Date.now() } })
}
const hidePanel = (e) => {
  const sp = document.getElementById('myPanel')
  if (sp && !sp.contains(e.target)) visible.value = false
}
const kaiGuanClick = (val) => { kaiGuan.value = val }
</script>

<style lang='less' scoped>
.zi-kuang-jia {
  height: 100%;
  .kaiGuan {
    height: calc(100% - 45px);
    position: absolute;
    bottom: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    .kaiGuanBut {
      height: 40px;
      width: 19px;
      border: 1px solid var(--frame_tone);
    }
  }
  .el-card + .el-card {
    margin-top: 10px;
  }
  .title {
    font-size: 20px;
    font-weight: bold;
  }

  // 内嵌导航
  .menu {
    width: 220px;
    height: calc(100% - 100px);
    background-color: var(--bg_nav);
    overflow: auto;
    position: fixed;
    transition: all 0.2s;
    :deep(.el-menu) {
      background-color: #393d49;
      border-right: none !important;
    }
    :deep(.el-sub-menu__title) {
      background-color: var(--bg_nav);
      color: var(--other_color);
    }
    :deep(.default_main_tone) {
      font-size: 16px;
    }
    :deep(.el-sub-menu__title:hover) {
      color: #fff;
      .default_main_tone {
        color: var(--select_main_tone) !important;
      }
    }
    .el-menu-item.is-active {
      background-color: var(--bg_blue);
      color: #fff;
    }
    .el-menu-item {
      background-color: var(--bg_black);
      color: var(--other_color);
      border-left: 3px solid #1e9eff00;
    }
    .el-menu-item:hover {
      color: #fff;
      border-left-color: #1e9eff;
    }
  }
  // @-webkit-keyframes slide-down{
  //   0%{transform: scale(1,0);}
  //   100%{transform: scale(1,1);}
  // }
  // //设置左侧菜单最大高度以及展开效果
  // .menu .el-sub-menu :deep(.el-menu) {
  //   max-height: calc(100vh - (56.4*10px)) !important;
  //   overflow: auto !important;
  //   transform-origin: 50% 0;
  //   -webkit-animation: slide-down .3s ease-in;
  //   transition: max-height .3s ease-out;
  // }

  // 框架
  .content {
    height: 100%;
    float: left;
    min-height: 100%;
    -webkit-transition: margin-left 0.28s;
    transition: margin-left 0.28s;
    position: relative;

    background-color: #fff;
    :deep(.el-tabs__header) {
      display: block;
      .el-tabs__item {
        transition: none;
      }
    }
    :deep(.el-tabs__item:nth-child(1)) {
      .el-icon {
        display: none;
      }
    }
    :deep(.el-tabs--border-card) {
      border: 0px;
    }
    :deep(.el-tabs__nav-scroll) {
      border-bottom: 0px;
    }
    // 标签
    .el-tabs {
      :deep(.el-tabs__content) {
        display: none;
      }
    }
    // 标签页内容区域
    .tab_nei_rong {
      height: calc(100% - 42px);
      .nei-rong {
        min-width: calc(1400px - 222px);
        min-height: calc(700px - 155px);
        height: 100%;
      }
    }
  }
  .subMenu :deep(.el-sub-menu__icon-arrow) {
    display: none;
  }
  .default_main_tone,
  .el-menu-item {
    font-size: 16px;
  }

  // //设置左侧菜单最大高度
  // .menu .el-sub-menu :deep(.el-menu) {
  //   max-height: calc(100vh - (56.4*10px)) !important;
  //   overflow: auto !important;
  // }
  // 右键菜单
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: fixed; //关键样式设置固定定位
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
  }

  .contextmenu li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;
    text-align: center;
  }
  .contextmenu li:hover {
    background: #eee;
  }
}
</style>
